import ReactGA from 'react-ga'
import AddToHomeScreen from './components/AddToHomeScreen'
import React, { Component } from 'react'
import Router from 'react-router-dom/BrowserRouter'
import Switch from 'react-router-dom/Switch'
import Route from 'react-router-dom/Route'
import { withRouter, Redirect } from 'react-router-dom'
import {
  OnBoarding,
  LoginAndSignup,
  Dashboard,
  Home,
  List,
  Products,
  Meals,
  PrivacyPolicy,
  SingleProduct,
  AboutUs,
  SingleList,
  OrderNow,
  ProductScanning,
  NominateBrand,
  NominateGrocery,
  ScanReceipt,
  UserProfile,
  EditProfile,
  ChangePassword,
  SpreadWord,
  OurTeam,
  FAQs,
  Blogs,
  Feedback,
  SingleFAQ,
  ResetPassword,
  ViewMore,
  Category,
  ProductType,
  ViewMoreFiltered
} from './pages'
import Cookies from 'js-cookie'
import axios from 'axios'
import { API_URL } from './constants'
// import qs from 'qs'
import { XCMText, FlexWrapper, Modal } from './components'
import { get, some, includes } from 'lodash'

ReactGA.initialize('UA-129080952-2', {
  debug: false,
  gaOptions: {
    userId: Cookies.get('user_id')
  }
})

const PrivateOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // Checking the access_token
      if (Cookies.get('access_token')) {
        const data = Cookies.getJSON('userDetails')
        Cookies.set('redirect', data.stage, { path: '/', expires: 365 })
        axios.defaults.headers['Authorization'] = `${Cookies.get('access_token')}`
        return (
          <React.Fragment>
            {Cookies.get('addtohomescreen') || get(data, 'saveToHomeScreen', true) === true ? '' : <AddToHomeScreen />}
            <Component {...props} />
          </React.Fragment>
        )
      } else {
        return (
          <Redirect
            to={{
              pathname: '/auth/social-login'
            }}
          />
        )
      }
    }}
  />
)

const PublicOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const token = Cookies.get('access_token')
      const page = Cookies.get('currentPage')
      console.log('Inside Public', page)
      return token ? (
        <Redirect to={{ pathname: page || '/home' }} />
      ) : (
        <React.Fragment>
          {props.location.pathname !== '/' && !Cookies.get('addtohomescreen') && <AddToHomeScreen />}
          <Component {...props} />
        </React.Fragment>
      )
    }}
  />
)
class Analytics extends React.Component {
  async componentDidMount() {
    if (Cookies.get('currentPage')) {
      this.props.history.push(Cookies.get('currentPage'))
      return
    }

    window.eval(
      'var OneSignal= window.OneSignal || [];OneSignal.push(function(){OneSignal.init({appId:"d4273cab-7c1f-4072-ad46-c75edb1786cc",autoRegister:!0,notifyButton:{enable:!1},welcomeNotification:{disable:!0},safari_web_id:"web.onesignal.auto.009a4322-838f-4341-bf26-c81fd75aa063"})});'
    )

    try {
      this.sendPageChange(this.props.location.pathname, this.props.location.search)
    } catch (error) {
      console.log(error)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      this.sendPageChange(this.props.location.pathname, this.props.location.search)
    }
  }

  async sendPageChange(pathname, search = '') {
    const page = pathname + search
    ReactGA.set({ page })
    ReactGA.ga('set', 'dimension1', navigator.standalone ? 'native' : 'web')
    ReactGA.pageview(page)
    Cookies.set('currentPage', pathname, { path: '/', expires: 10 / 1440 })
    const data = Cookies.getJSON('userDetails')
    if (data && data.saveToHomeScreen === false && navigator.standalone) {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}?access_token=${Cookies.get('access_token')}`, {
        saveToHomeScreen: true
      })
    }
  }
  render() {
    return null
  }
}
const AnalyticsTracker = () => {
  return <Route component={Analytics} />
}

class ScrollToTop extends Component {
  componentDidMount() {
    this.props.history.listen((location, action) => {
      if (this.props.history.length === 0) {
        this.props.history.replace('/home')
      }
    })
  }
  componentDidUpdate(prevProps) {
    const avoidScrollToTop = ['/green-score', '/basic-info', '/grocery-store']
    console.log(this.props.match)
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      !some(avoidScrollToTop, el => includes(this.props.location.pathname, el))
    ) {
      window.scrollTo(0, 0)
    }
  }
  render() {
    return this.props.children
  }
}

const RoutedScroll = withRouter(ScrollToTop)
class App extends Component {
  state = {
    showModal: true
  }
  render() {
    /*   if ('standalone' in window.navigator && !window.navigator.standalone) {
      alert('full screen')
    } else {
      console.log('standalone', window)
    } */

    const { showModal } = this.state
    if (/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      return (
        <Modal title="SORRY!" show={showModal}>
          <FlexWrapper alignItems="center">
            <XCMText>For the best experience please use the app in the Safari browser</XCMText>
            {/* <DefaultText>Open in Safari:</DefaultText> */}
          </FlexWrapper>
        </Modal>
      )
    } else {
      return (
        <Router>
          <RoutedScroll>
            <AnalyticsTracker />
            <Switch>
              <PublicOnlyRoute exact path="/" component={OnBoarding} />
              <PublicOnlyRoute exact path="/auth/:tab" component={LoginAndSignup} />
              <PublicOnlyRoute exact path="/reset-password/:id/:token" component={ResetPassword} />
              <PrivateOnlyRoute exact path="/dashboard/:tab" component={Dashboard} />
              <PrivateOnlyRoute exact path="/dashboard/:tab/edit" component={Dashboard} />
              <PrivateOnlyRoute exact path="/home" component={Home} />
              <PrivateOnlyRoute exact path="/lists" component={List} />
              <PrivateOnlyRoute exact path="/lists/:tab" component={SingleList} />
              <PrivateOnlyRoute exact path="/lists/:tab/:tab1" component={SingleList} />
              <PrivateOnlyRoute exact path="/lists/:tab/:tab1/:tab" component={OrderNow} />
              <PrivateOnlyRoute exact path="/products" component={Products} />
              <Route exact path="/products/:tab" component={SingleProduct} />
              <Route exact path="/products/:tab/:tab1" component={SingleProduct} />
              <PrivateOnlyRoute exact path="/meals" component={Meals} />
              <PrivateOnlyRoute exact path="/productscanning" component={ProductScanning} />
              <PrivateOnlyRoute exact path="/scan-receipt" component={ScanReceipt} />
              <PrivateOnlyRoute exact path="/gcnow-stories" component={Blogs} />
              <PrivateOnlyRoute exact path="/favorites" component={ViewMore} />
              <PrivateOnlyRoute exact path="/best-for-you" component={ViewMoreFiltered} />
              <PrivateOnlyRoute exact path="/best-scores" component={ViewMoreFiltered} />
              <PrivateOnlyRoute exact path="/recently-searched" component={ViewMore} />
              <PrivateOnlyRoute exact path="/gcnow-stories/:key" component={Blogs} />
              {/* <PrivateOnlyRoute exact path="/favorites" component={AllFavorites} /> */}
              <PrivateOnlyRoute exact path="/user-profile" component={UserProfile} />
              <PrivateOnlyRoute exact path="/user-profile/edit" component={EditProfile} />
              <PrivateOnlyRoute exact path="/user-profile/change-password" component={ChangePassword} />
              <PrivateOnlyRoute exact path="/aboutus" component={AboutUs} />
              <PrivateOnlyRoute exact path="/privacy-policy" component={PrivacyPolicy} />
              <PrivateOnlyRoute exact path="/feedback" component={Feedback} />
              <PrivateOnlyRoute exact path="/nominate-grocery" component={NominateGrocery} />
              <PrivateOnlyRoute exact path="/nominate-brand" component={NominateBrand} />
              <PrivateOnlyRoute exact path="/invite" component={SpreadWord} />
              <PrivateOnlyRoute exact path="/our-team" component={OurTeam} />
              <PrivateOnlyRoute exact path="/faq" component={FAQs} />
              <PrivateOnlyRoute exact path="/faq/:tab" component={SingleFAQ} />
              <PrivateOnlyRoute exact path="/category/:tab" component={Category} />
              <PrivateOnlyRoute exact path="/category/:tab/:tab1" component={ProductType} />
              <Redirect
                to={{
                  pathname: '/'
                }}
              />
            </Switch>
          </RoutedScroll>
        </Router>
      )
    }
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js